import React, { useState } from 'react';

export default function AdminAssignModal({ open, onClose, onSubmit, title = 'Assign Admin', initial = null, submitting = false }) {
  const [name, setName] = useState(initial?.name || '');
  const [phone, setPhone] = useState(initial?.phone || '');
  const [email, setEmail] = useState(initial?.email || '');
  const [password, setPassword] = useState('');

  // Reset when target changes
  React.useEffect(() => {
    setName(initial?.name || '');
    setPhone(initial?.phone || '');
    setEmail(initial?.email || '');
    setPassword('');
  }, [initial?.name, initial?.phone, initial?.email]);

  if (!open) return null;

  const submit = (e) => {
    e.preventDefault();
    onSubmit?.({ name, phone, email, password });
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0 bg-black/40" onClick={onClose} />
      <div className="relative bg-white rounded-xl shadow-xl w-full max-w-lg p-6">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-semibold">{title}</h3>
          <button className="text-gray-500 hover:text-gray-700" onClick={onClose}>✕</button>
        </div>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="block text-sm text-gray-700 mb-1">Admin Name</label>
            <input className="w-full border rounded-lg p-2" value={name} onChange={(e)=>setName(e.target.value)} required />
          </div>
          <div>
            <label className="block text-sm text-gray-700 mb-1">Admin Phone</label>
            <input className="w-full border rounded-lg p-2" value={phone} onChange={(e)=>setPhone(e.target.value)} required />
          </div>
          <div>
            <label className="block text-sm text-gray-700 mb-1">Admin Email</label>
            <input type="email" className="w-full border rounded-lg p-2" value={email} onChange={(e)=>setEmail(e.target.value)} required />
          </div>
          <div>
            <label className="block text-sm text-gray-700 mb-1">Temporary Password</label>
            <input type="password" className="w-full border rounded-lg p-2" value={password} onChange={(e)=>setPassword(e.target.value)} required />
          </div>
          <div className="flex items-center justify-end gap-2 pt-2">
            <button type="button" className="px-4 py-2 rounded bg-gray-100 text-gray-800" onClick={onClose} disabled={submitting}>Cancel</button>
            <button type="submit" className="px-4 py-2 rounded bg-indigo-600 text-white" disabled={submitting}>{submitting ? 'Assigning...' : 'Assign'}</button>
          </div>
        </form>
      </div>
    </div>
  );
}
